'use strict';

var $ = require('jquery'),
  Backbone = require('backbone'),
  $global = require('../globalElements');

Backbone.$ = $;

var SideNav = Backbone.View.extend({

  events: {
    'click .SideNav-title, .Overlay--SideNav': 'toggleNav',
    'click .SideNav-menu-item': 'itemClicked'
  },

  initialize() {
    this.overlay = $('<div class="Overlay Overlay--SideNav" />');
    this.$el.prepend(this.overlay);
  },

  toggleNav() {
    this.$el.toggleClass('is-open');
    if (this.$el.is('.is-open')) {
      this.overlayH = $global.$document.height() - this.$el.offset().top;
      this.overlay.css('height', this.overlayH);
    } else {
      this.overlay.css('height', 0);
    }
  },
  itemClicked() {
    this.$el.removeClass('is-open');
  }
});

module.exports = SideNav;



// WEBPACK FOOTER //
// ./assets/js/navigation/sideNav.js